export default {
	title: "Exit before saving?",
	description: "Are you sure you want to exit before saving?",
	confirmButton: "Yes, exit",
	saveButton: "Save as draft",
	dismissButton: "Cancel",
};
